import { FETCH_POIS, SET_HOVERED_POI_ID, SET_POI, SET_POIS } from "./constants";
import initialState from "./initialState";

export default (state = initialState, action) => {
	switch (action.type) {
		case FETCH_POIS:
			return {
				...action.pois
			};
		case SET_POIS:
			return {
				...initialState
			};
		case SET_POI:
			return {
				...state,
				poi: action.poi
			};
		case SET_HOVERED_POI_ID:
			return {
				...state,
				poi: action.poi
			};

		default:
			return state;
	}
};
